import { connect } from 'react-redux'
import ApplicationsComponent from '../../components/openforwork/applications.component'
import {
  getAllAssignments,
  trackApplication,
  getAssignmentOfferToEmail,
  openSignBox,
  cancelOpenSignBox,
  askBeforeRejectAssignment,
  cancelRejectAssignment,
  rejectAssignment,
  getApplicationProfile,
  loadProfileStart,
  closeApplicationProfile,
  signAndSendAssignment,
  closeApplicationSnackbar,
  applicationListPageChange,
  getAreaOfWork,
  updateViewApplication,
  pinApplication,
  pinAssignment,
  saveInvoiceDraft,
  editInvoice
} from '../../actions'
import { convertDataToDict } from '../../utils/showIndustry.utils'
import { groupAssignmentByCompany } from './assignments.container'
const mapStateToProps = (state) => {
  const areaOfWorkDict = convertDataToDict(state.openForWork.areaOfWorkList)

  const mergedMyAssignmentsAndAppliedData =
    mergeAppliedDataWithMyAssignmentRows(
      state.assignment.appliedData,
      state.assignment.myAssignmentRows
    )

  const myAssignmentRows_merged = groupAssignmentByCompany(
    mergedMyAssignmentsAndAppliedData
  )

  return {
    state,
    myAssignmentRows: mergedMyAssignmentsAndAppliedData,
    applicationPages: !!myAssignmentRows_merged
      ? Math.ceil(myAssignmentRows_merged.length / 10)
      : 0,
    signPad: state.application.signPad,
    openBeforeRejectDialog: state.application.openBeforeRejectDialog,
    applicationProfileOpen: state.application.applicationProfileOpen,
    applicationProfileData: state.application.applicationProfileData[0],
    userData: state.client.user.data,
    profileData: state.profile.userData,
    selectedApplicationToSeeProfile:
      state.application.selectedApplicationToSeeProfile,
    showSnackbar: state.application.showSnackbar,
    showFailedSnackbar: state.application.showFailedSnackbar,
    appliedData: state.assignment.appliedData,
    applicationListPages: !!state.assignment.appliedData
      ? Math.ceil(state.assignment.appliedData.length / 10)
      : 0,
    pageSelected: state.application.pageSelected,
    showSignSendLoader: state.loader.showSignSendLoader,
    areaOfWorkDict: areaOfWorkDict,
    saveDraftInvoiceSuccess: state.application.saveDraftInvoiceSuccess,
    saveDraftInvoiceFailed: state.application.saveDraftInvoiceFailed,
    isSeeMyApplication: state.assignment.isSeeMyApplication
  }
}

// Function to merge applied data with offered assignments
// If assignment_id in applied data = assignment_job_id in offered assignments doesn't merge that record applied data
function mergeAppliedDataWithMyAssignmentRows(appliedData, myAssignmentRows) {
  // Get all assignment_job_id in my assignment rows
  const idsInMyAssignmentRows = new Set(
    myAssignmentRows.map((row) => row.assignment_job_id)
  )
  const newItems = appliedData.filter(
    (item) => !idsInMyAssignmentRows.has(item.assignment_id)
  )
  return [...myAssignmentRows, ...newItems]
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    trackApplication: () => dispatch(trackApplication()),
    getAssignmentOfferToEmail: () => dispatch(getAssignmentOfferToEmail()),
    getAllAssignments: () => dispatch(getAllAssignments()),
    openSignBox: (assignmentData) => dispatch(openSignBox(assignmentData)),
    cancelOpenSignBox: () => dispatch(cancelOpenSignBox()),
    askBeforeRejectAssignment: (assignmentData) =>
      dispatch(askBeforeRejectAssignment(assignmentData)),
    cancelRejectAssignment: () => dispatch(cancelRejectAssignment()),
    rejectAssignment: (reason, data) =>
      dispatch(rejectAssignment(reason, data)),
    getApplicationProfile: (values) => dispatch(getApplicationProfile(values)),
    loadProfileStart: () => dispatch(loadProfileStart()),
    closeApplicationProfile: () => dispatch(closeApplicationProfile()),
    signAndSendAssignment: (offerData, trim, draftInvoiceValues) =>
      dispatch(signAndSendAssignment(offerData, trim, draftInvoiceValues)),
    closeApplicationSnackbar: () => dispatch(closeApplicationSnackbar()),
    applicationListPageChange: (selected) =>
      dispatch(applicationListPageChange(selected)),
    getAreaOfWork: () => dispatch(getAreaOfWork()),
    updateViewApplication: (agreement_id) =>
      dispatch(updateViewApplication(agreement_id)),
    pinApplication: (agreement_id) => dispatch(pinApplication(agreement_id)),
    pinAssignment: (assignment_id) => dispatch(pinAssignment(assignment_id)),
    saveInvoiceDraft: (formValues) => dispatch(saveInvoiceDraft(formValues)),
    editInvoice: (formValues) => dispatch(editInvoice(formValues))
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const ApplicationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ApplicationsComponent)

export default ApplicationsContainer
